import { mutatorAction } from "satcheljs";
import { SchedulesViewStateStore } from "sh-application/components/schedules/lib/store/schema/SchedulesViewStateStore";
import { IPreviewSchedulePageStore } from "sh-application/components/previewSchedulePage";

/**
 * Sets the boolean to indicate the header is expanded
 * @param viewState - Schedule view state
 * @param isHeaderExpanded - boolean determining if the header is expanded
 */
export default mutatorAction("SET_IS_HEADER_EXPANDED",
    function setIsHeaderExpanded(viewState: SchedulesViewStateStore | IPreviewSchedulePageStore, isHeaderExpanded: boolean) {
        viewState.isHeaderExpanded = isHeaderExpanded;
    }
);